// /frontend/src/services/cartService.js (With debugging)
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/cart`;

// Get cart items
const getCart = async () => {
  try {
    console.log('Getting cart data');
    const response = await apiClient.get(API_URL);
    console.log('Cart data received:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching cart:', error.response?.data || error.message);
    throw error.response?.data?.error || 'Failed to load cart';
  }
};

// Add item to cart
const addToCart = async (productId, quantity, variants = {}) => {
  try {
    const payload = {
      productId,
      quantity,
      variants
    };
    
    console.log('Adding to cart with payload:', JSON.stringify(payload));
    
    const response = await apiClient.post(`${API_URL}/add`, payload);
    console.log('Add to cart response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('Error adding to cart:', error.response?.data || error.message);
    throw error.response?.data?.error || 'Failed to add item to cart';
  }
};

// Update cart item quantity
const updateCartItem = async (itemId, quantity) => {
  try {
    console.log(`Updating cart item ${itemId} quantity to ${quantity}`);
    const response = await apiClient.put(`${API_URL}/update/${itemId}`, { quantity });
    console.log('Update cart item response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('Error updating cart item:', error.response?.data || error.message);
    throw error.response?.data?.error || 'Failed to update item quantity';
  }
};

// Remove item from cart
const removeFromCart = async (itemId) => {
  try {
    console.log(`Removing item ${itemId} from cart`);
    const response = await apiClient.delete(`${API_URL}/remove/${itemId}`);
    console.log('Remove from cart response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('Error removing from cart:', error.response?.data || error.message);
    throw error.response?.data?.error || 'Failed to remove item from cart';
  }
};

// Clear cart
const clearCart = async () => {
  try {
    console.log('Clearing cart');
    const response = await apiClient.delete(`${API_URL}/clear`);
    console.log('Clear cart response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('Error clearing cart:', error.response?.data || error.message);
    throw error.response?.data?.error || 'Failed to clear cart';
  }
};

export const cartService = {
  getCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart
};